import { render, staticRenderFns } from "./PathwayViewCoursesCard.vue?vue&type=template&id=10b0b4a4&"
import script from "./PathwayViewCoursesCard.vue?vue&type=script&lang=js&"
export * from "./PathwayViewCoursesCard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports